import api from "../../utils/ApiConfig";

export const fetchActionsData = async (page = 1, searchTerm = "") => {
  try {
    const response = await api.get(`/bo/audits`, {
      params: {
        page: page,
        per_page: 50,
        search: searchTerm,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching actions data:", error);
    throw error;
  }
};
